"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addListButtons = addListButtons;
exports.listNodes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _TinyMceListMenu = _interopRequireDefault(require("../components/toolbar/TinyMceListMenu"));

var _InsertControlButton = _interopRequireDefault(require("../components/toolbar/InsertControlButton"));

var _toolbar = require("../constants/toolbar");

var _hsformatting = require("../constants/hsformatting");

var _i18n = require("../utils/i18n");

var _utils = require("./utils");

var i18nKey = (0, _i18n.i18nWithNameSpace)(_hsformatting.i18nNameSpace);
var listNodes = ['LI', 'UL', 'OL', 'DL'];
exports.listNodes = listNodes;

var getListChange = function getListChange(editor, nodeName, defaultValue) {
  var isInsert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (value) {
    editor.undoManager.transact(function () {
      var dom = editor.dom,
          selection = editor.selection;
      var command = nodeName === 'UL' ? 'InsertUnorderedList' : 'InsertOrderedList';
      var newValue = value === defaultValue ? null : value;
      var list = dom.getParent(selection.getNode(), 'ul,ol');

      if (isInsert || !list || list.nodeName !== nodeName) {
        editor.execCommand(command);
      }

      list = dom.getParent(selection.getNode(), 'ul,ol');

      if (list) {
        dom.setStyle(list, 'listStyleType', newValue); // Ported from the adv list plugin https://git.hubteam.com/HubSpot/tinymce/blob/master/static/js/tinymce/plugins/advlist/plugin.js#L57

        list.removeAttribute('data-mce-style');
      }

      editor.focus();
    });
  };
};

var listButtonControls = [{
  controlName: 'canvasbullistbutton',
  tooltip: 'tooltip.bulletlist',
  nodeName: 'UL',
  styleType: {
    icon: 'bulletList',
    value: 'default'
  }
}, {
  controlName: 'canvasnumlistbutton',
  tooltip: 'tooltip.numlist',
  nodeName: 'OL',
  styleType: {
    icon: 'numberList',
    value: 'default'
  }
}];
var listControls = [{
  controlName: 'canvasbullist',
  tooltip: 'tooltip.bulletlist',
  nodeName: 'UL',
  options: [{
    icon: 'bulletList',
    value: 'default'
  }, {
    icon: 'bulletCircle',
    value: 'circle'
  }, {
    icon: 'bulletSquare',
    value: 'square'
  }]
}, {
  controlName: 'canvasnumlist',
  tooltip: 'tooltip.numlist',
  nodeName: 'OL',
  options: [{
    icon: 'numberList',
    value: 'default'
  }, {
    icon: 'bulletUpperRoman',
    value: 'upper-roman'
  }, {
    icon: 'bulletUpperAlpha',
    value: 'upper-alpha'
  }, {
    icon: 'bulletLowerRoman',
    value: 'lower-roman'
  }, {
    icon: 'bulletLowerAlpha',
    value: 'lower-alpha'
  }, {
    icon: 'bulletLowerGreek',
    value: 'lower-greek'
  }]
}];

var indentControlHandler = function indentControlHandler(editor) {
  var blocks = editor.selection.getSelectedBlocks();
  var isDisabled = false;

  for (var i = 0, l = blocks.length; !isDisabled && i < l; i++) {
    var tag = blocks[i].nodeName;
    isDisabled = tag === listNodes[0] && (0, _utils.isFirstChild)(blocks[i]) || listNodes.indexOf(tag) > 0;
  }

  editor.fire("FormatChanged:indent", {
    isDisabled: isDisabled
  });
};

function addListButtons(editor) {
  // List controls as select menu
  listControls.forEach(function (_ref) {
    var controlName = _ref.controlName,
        tooltip = _ref.tooltip,
        nodeName = _ref.nodeName,
        options = _ref.options;
    var defaultValue = options[0].value;
    editor.addButton(controlName, {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_TinyMceListMenu.default, (0, _extends2.default)({
          editor: editor,
          nodeName: nodeName,
          indentControlHandler: indentControlHandler,
          defaultValue: defaultValue,
          tooltip: i18nKey(tooltip),
          onClick: getListChange(editor, nodeName, defaultValue, true),
          onListTypeChange: getListChange(editor, nodeName, defaultValue),
          options: options
        }, props));
      }
    });
  });

  var getIsActiveHandler = function getIsActiveHandler(nodeName) {
    return function (event) {
      if (!event.parents) return false;
      return !!event.parents.find(function (parent) {
        return parent.nodeName === nodeName;
      });
    };
  }; // List controls as button


  listButtonControls.forEach(function (_ref2) {
    var controlName = _ref2.controlName,
        tooltip = _ref2.tooltip,
        nodeName = _ref2.nodeName,
        styleType = _ref2.styleType;
    var icon = styleType.icon,
        value = styleType.value;
    var onListChange = getListChange(editor, nodeName, value, true);
    editor.addButton(controlName, {
      type: _toolbar.CANVAS_BUTTON_TYPE,
      renderControl: function renderControl(props) {
        return _react.default.createElement(_InsertControlButton.default, (0, _extends2.default)({
          editor: editor,
          iconName: icon,
          tooltip: i18nKey(tooltip),
          onClick: function onClick() {
            return onListChange(value);
          },
          isActiveHandler: getIsActiveHandler(nodeName)
        }, props));
      }
    });
  });
}